<p-toast></p-toast>
<p-card styleClass="p-card-shadow">
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- left template -->
            </ng-template>
            <ng-template pTemplate="right">
                <button (click)="menu.toggle($event)" pButton pRipple label="{{ 'EXPORT' | translate }}"
                    icon="pi pi-upload" class="p-button-help"></button>

                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>
        </p-toolbar>
        <p-table #dataTable [value]="stf_lot_report" dataKey="Lot_No" [rows]="10" [paginator]="true"
            [globalFilterFields]="[
            'Lot_No',
            'AppID',
            'Subsidy_Amt',
            'CenterShare_Amount',
            'StateShare_Amount',
            'Topup',
            'ABY',
            'CreatedDate',
            'PFMSPaymentDate',
            'TopUpPFMSPaymentDate',
            'Status',
            'Remarks',
            'Fin_Year'

      ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Lot_No" currentPageReportTemplate="{{ 'SHOWING' | translate }} {first} {{
        'TO' | translate
      }} {last} {{ 'OF' | translate }} {totalRecords} {{
        'ENTRIES' | translate
      }}" [showCurrentPageReport]="true" [loading]="loading">
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                    <h5 class="m-0">{{ "TANK_STAGE1_LOT_REPORT" | translate }}</h5>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="
                dataTable.filterGlobal($any($event.target).value, 'contains')
              " placeholder="{{ 'SEARCH' | translate }}" />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="Lot_No">
                        {{ "LOT_NO" | translate }}
                        <p-columnFilter type="text" field="Lot_No" display="menu"></p-columnFilter>
                        <p-sortIcon field="Lot_No"></p-sortIcon>
                    </th>
                    <th pSortableColumn="AppID">
                        {{ "APP_ID" | translate }}
                        <p-columnFilter type="text" field="AppID" display="menu"></p-columnFilter>
                        <p-sortIcon field="AppID"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Subsidy_Amt">
                        {{ "SUBSIDY_AMOUNT" | translate }}
                        <p-columnFilter type="text" field="Subsidy_Amt" display="menu"></p-columnFilter>
                        <p-sortIcon field="Subsidy_Amt"></p-sortIcon>
                    </th>
                    <th pSortableColumn="CenterShare_Amount">
                        {{ "CENTER_SHARE_AMOUNT" | translate }}
                        <p-columnFilter type="text" field="CenterShare_Amount" display="menu"></p-columnFilter>
                        <p-sortIcon field="CenterShare_Amount"></p-sortIcon>
                    </th>
                    <th pSortableColumn="StateShare_Amount">
                        {{ "STATE_SHARE_AMOUNT" | translate }}
                        <p-columnFilter type="text" field="StateShare_Amount" display="menu"></p-columnFilter>
                        <p-sortIcon field="StateShare_Amount"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Topup">
                        {{ "TOP_UP_AMOUNT" | translate }}
                        <p-columnFilter type="text" field="Topup" display="menu"></p-columnFilter>
                        <p-sortIcon field="Topup"></p-sortIcon>
                    </th>
                    <th pSortableColumn="ABY">
                        {{ "ABY_AMOUNT" | translate }}
                        <p-columnFilter type="text" field="ABY" display="menu"></p-columnFilter>
                        <p-sortIcon field="ABY"></p-sortIcon>
                    </th>
                    <th pSortableColumn="CreatedDate">
                        {{ "CREATED_DATE" | translate }}
                        <p-columnFilter type="text" field="CreatedDate" display="menu"></p-columnFilter>
                        <p-sortIcon field="CreatedDate"></p-sortIcon>
                    </th>
                    <th pSortableColumn="PFMSPaymentDate">
                        {{ "PFMS_PAYMENT_DATE" | translate }}
                        <p-columnFilter type="text" field="PFMSPaymentDate" display="menu"></p-columnFilter>
                        <p-sortIcon field="PFMSPaymentDate"></p-sortIcon>
                    </th>
                    <th pSortableColumn="TopUpPFMSPaymentDate">
                        {{ "TOP_UP_PFMS_PAYMENT_DATE" | translate }}
                        <p-columnFilter type="text" field="TopUpPFMSPaymentDate" display="menu"></p-columnFilter>
                        <p-sortIcon field="TopUpPFMSPaymentDate"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Status">
                        {{ "STATUS" | translate }}
                        <p-columnFilter type="text" field="Status" display="menu"></p-columnFilter>
                        <p-sortIcon field="Status"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Remarks">
                        {{ "REMARKS" | translate }}
                        <p-columnFilter type="text" field="Remarks" display="menu"></p-columnFilter>
                        <p-sortIcon field="Remarks"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Fin_Year">
                        {{ "FINANCIAL_YEAR" | translate }}
                        <p-columnFilter type="text" field="Fin_Year" display="menu"></p-columnFilter>
                        <p-sortIcon field="Fin_Year"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-lot_report>
                <tr>
                    <td>{{ lot_report?.Lot_No }}</td>
                    <td>{{ lot_report?.AppID }}</td>
                    <td>{{ lot_report?.Subsidy_Amt }}</td>
                    <td>{{ lot_report?.CenterShare_Amount }}</td>
                    <td>{{ lot_report?.StateShare_Amount }}</td>
                    <td>{{ lot_report?.Topup }}</td>
                    <td>{{ lot_report?.ABY }}</td>
                    <td>{{ lot_report?.CreatedDate | date : "mediumDate" }}</td>
                    <td>{{ lot_report?.PFMSPaymentDate | date : "mediumDate" }}</td>
                    <td>{{ lot_report?.TopUpPFMSPaymentDate | date : "mediumDate" }}</td>
                    <td>{{ lot_report?.Status }}</td>
                    <td>{{ lot_report?.Remarks }}</td>
                    <td>{{ lot_report?.Fin_Year }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-card>